import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@ff-os/shared-react/components/buttons/button/Button';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { ChangePhotoVariantMethod } from '../../../thunks/changePhotoVariant';
import styles from './ChangeGroupButtons.module.scss';

export const ChangeGroupButtons = ({ ctaMethod = 'copy', onSelect }: Props) => {

    const { t } = useTranslation();

    const textFor = (method: ChangePhotoVariantMethod) =>
        `photo_prints.options.method.${method}.short`;

    return (
        <Grid align='stretch' gap='m'>
            <Cell>
                <Button
                    className={styles.button}
                    onClick={() => onSelect('copy')}
                    style={ctaMethod !== 'copy' ? 'outline' : undefined}>
                    {t(textFor('copy'))}
                </Button>
            </Cell>
            <Cell>
                <Button
                    className={styles.button}
                    onClick={() => onSelect('move')}
                    style={ctaMethod !== 'move' ? 'outline' : undefined}>
                    {t(textFor('move'))}
                </Button>
            </Cell>
        </Grid>
    );
};

type Props = {
    ctaMethod?: ChangePhotoVariantMethod;
    onSelect: (mode: ChangePhotoVariantMethod) => void;
};